import React from 'react';
import { DatePicker, Space, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import moment, { Moment } from 'moment';
const { Text } = Typography;

interface Props {
    setFilters: (data: Object) => void;
}

const Filter = (props: Props) => {

    React.useEffect(() => {
        props.setFilters({
            month: moment().format('MM'),
            year: moment().format('YYYY')
        });
    }, [])

    const handleDateChange = (date: Dayjs) => {

        props.setFilters({
            month: date.format('MM'),
            year: date.format('YYYY')
        });
    };


    return (
        <Space direction="vertical" size={12}>

            <div>

                <Text>Select Year-Month : </Text>
                <DatePicker
                    defaultValue={dayjs()}
                    format={'YYYY-MM'}
                    onChange={handleDateChange}
                    allowClear={false}
                    picker="month"
                    placeholder="Select Month"
                />
            </div>
        </Space>
    )
}

export default Filter